import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Banner = (props) => {
	const onclickItem = (item) => {
		window.open(props.data[item].url, "_blank") //to open new page
	}

	return (
		<Carousel
			autoPlay={true}
			infiniteLoop={true}
			showThumbs={false}
			showIndicators={false}
			showArrows={false}
			showStatus={false}
			width='100%'
			onClickItem={onclickItem}
		>
			{props.data && props.data.map((item) => {
				return (
					<img style={{width: "95%" }} src={item.image} alt={"carousel-image"}/>
				)
			}) }
		</Carousel>
	)
}

export default Banner